// extracted by mini-css-extract-plugin
module.exports = {"yLabel":"DumbellChart_yLabel__qUzy7"};